/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Rain_ModerateInputs */

const en_ui_weather_rain_moderate = /** @type {(inputs: Ui_Weather_Rain_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate rain`)
};

const de_ui_weather_rain_moderate = /** @type {(inputs: Ui_Weather_Rain_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mäßiger Regen`)
};

/**
* | output |
* | --- |
* | "Moderate rain" |
*
* @param {Ui_Weather_Rain_ModerateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_rain_moderate = /** @type {((inputs?: Ui_Weather_Rain_ModerateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Rain_ModerateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_rain_moderate(inputs)
	return de_ui_weather_rain_moderate(inputs)
});